import React, { useEffect, useState } from 'react';
import { API_BASE } from '../config/api';
import EditarPedidoDocente from './EditarPedidoDocente';

const MisPedidos = () => {
  const [pedidos, setPedidos] = useState([]);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [cargandoEdicion, setCargandoEdicion] = useState(false);

  const profesorId = localStorage.getItem('profesorId');

  useEffect(() => {
    const cargarPedidos = async () => {
      if (!profesorId) return;

      try {
        const res = await fetch(`${API_BASE}/api/profesores/${profesorId}/pedidos`);
        if (!res.ok) throw new Error('No se pudo cargar pedidos');

        const data = await res.json();
        setPedidos(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error al cargar pedidos:', error);
        setPedidos([]);
      }
    };

    cargarPedidos();
  }, [profesorId]);

  const actualizarPedidos = async () => {
    if (!profesorId) return;

    try {
      const res = await fetch(`${API_BASE}/api/profesores/${profesorId}/pedidos`);
      if (!res.ok) throw new Error('No se pudo actualizar pedidos');

      const data = await res.json();
      setPedidos(Array.isArray(data) ? data : []);
      setPedidoSeleccionado(null);
    } catch (error) {
      console.error('Error al actualizar pedidos:', error);
    }
  };

  // ✅ Abrir modal pero trayendo pedido completo antes
  const abrirEditar = async (pedidoBasico) => {
    setCargandoEdicion(true);
    try {
      const res = await fetch(`${API_BASE}/api/pedidos/${pedidoBasico.id}`);
      const data = res.ok ? await res.json() : null;

      if (!data) {
        alert('No se pudo cargar el pedido completo para editar.');
        return;
      }

      // Mezclamos lo básico + lo completo (por seguridad)
      setPedidoSeleccionado({ ...pedidoBasico, ...data });
    } catch (e) {
      console.error('Error cargando pedido completo:', e);
      alert('Error al cargar el pedido para editar.');
    } finally {
      setCargandoEdicion(false);
    }
  };

  // Cerrar modal con ESC
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setPedidoSeleccionado(null);
    };
    if (pedidoSeleccionado) window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [pedidoSeleccionado]);

  // Bloquear scroll del body mientras el modal está abierto
  useEffect(() => {
    if (!pedidoSeleccionado) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [pedidoSeleccionado]);

  return (
    <div className="p-4 md:p-6 mt-4">
      <h2 className="text-2xl font-bold mb-4 text-blue-700">Mis Pedidos Realizados</h2>

      {pedidos.length === 0 ? (
        <p className="text-gray-600">No tienes pedidos registrados.</p>
      ) : (
        <>
          {/* ✅ TABLA DESKTOP */}
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-full bg-white shadow rounded">
              <thead>
                <tr className="bg-blue-100 text-left">
                  <th className="px-4 py-2">Tipo</th>
                  <th className="px-4 py-2">Colegio</th>
                  <th className="px-4 py-2">Descripción</th>
                  <th className="px-4 py-2">Estado</th>
                  <th className="px-4 py-2">Fecha</th>
                  <th className="px-4 py-2">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {pedidos.map((pedido) => (
                  <tr key={pedido.id} className="border-t hover:bg-gray-50">
                    <td className="px-4 py-2">{pedido.tipo_pedido}</td>
                    <td className="px-4 py-2">{pedido.colegio || 'Sin colegio'}</td>
                    <td className="px-4 py-2">{pedido.descripcion_problema}</td>
                    <td className="px-4 py-2 capitalize">{pedido.estado}</td>
                    <td className="px-4 py-2">
                      {pedido.fecha ? new Date(pedido.fecha).toLocaleString() : '-'}
                    </td>
                    <td className="px-4 py-2">
                      {pedido.estado === 'pendiente' && (
                        <button
                          onClick={() => abrirEditar(pedido)}
                          className="bg-yellow-400 text-white px-3 py-1 rounded hover:bg-yellow-500 transition"
                        >
                          Modificar
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ✅ TARJETAS MOBILE */}
          <div className="md:hidden space-y-4">
            {pedidos.map((p) => (
              <div key={p.id} className="bg-white shadow rounded-lg p-4">
                <div className="flex justify-between items-center">
                  <span className="font-semibold text-blue-700">#{p.id}</span>
                  <span
                    className={`text-sm capitalize px-2 py-1 rounded ${
                      p.estado === 'pendiente'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-green-100 text-green-800'
                    }`}
                  >
                    {p.estado}
                  </span>
                </div>

                <div className="mt-2 text-sm space-y-1">
                  <p>
                    <strong>Tipo:</strong> {p.tipo_pedido}
                  </p>
                  <p>
                    <strong>Colegio:</strong> {p.colegio || 'Sin colegio'}
                  </p>
                </div>

                <p className="mt-2 text-gray-600 text-sm">{p.descripcion_problema}</p>

                <div className="mt-3 text-xs text-gray-500">
                  {p.fecha ? new Date(p.fecha).toLocaleString() : '-'}
                </div>

                {p.estado === 'pendiente' && (
                  <div className="mt-4">
                    <button
                      onClick={() => abrirEditar(p)}
                      className="w-full bg-yellow-400 text-white py-2 rounded text-sm hover:bg-yellow-500 transition"
                      disabled={cargandoEdicion}
                    >
                      {cargandoEdicion ? 'Cargando...' : 'Modificar'}
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {/* ✅ MODAL EDITAR PEDIDO (móvil: siempre visible) */}
      {pedidoSeleccionado && (
        <div
          className="fixed inset-0 z-[9999] bg-black/40 p-3 md:p-6 overflow-y-auto"
          onClick={() => setPedidoSeleccionado(null)}
        >
          <div
            className="w-full max-w-3xl bg-white rounded-xl shadow-2xl overflow-hidden mx-auto mt-3 md:mt-10"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-white">
              <div>
                <h3 className="text-lg font-bold">Modificar pedido</h3>
                <p className="text-sm opacity-90">
                  Pedido: <span className="font-semibold">#{pedidoSeleccionado.id}</span>
                </p>
              </div>
              <button
                onClick={() => setPedidoSeleccionado(null)}
                className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded"
                title="Cerrar"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="p-4">
              <EditarPedidoDocente
                pedido={pedidoSeleccionado}
                onClose={() => setPedidoSeleccionado(null)}
                onActualizar={actualizarPedidos}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MisPedidos;
